<template>
  <v-container fluid grid-list-lg>
    <Create :createDialog="createDialog" @close="createDialog = !createDialog" @submit="getList"></Create>
    <Edit :editDialog="editDialog" @close="editDialog = !editDialog" @submit="getList" :id="id"></Edit>
    <v-card :loading="loading" outlined>
      <ListTitle :access="checkRightStatus(1)" title="Account" @add="add" />

      <v-card-title>
        <v-flex xs12 sm4>
          <v-text-field v-model="search" outlined prepend-inner-icon="search" rounded dense label="Search" single-line
            hide-details clearable></v-text-field>
        </v-flex>
        <v-spacer></v-spacer>
        <!-- <v-flex shrink>
          <v-switch
            v-model="hideZeroProduct"
            color="yellow darken-1"
            hide-details
            label="Hide product zero or less"
          ></v-switch>
        </v-flex> -->
      </v-card-title>
      <v-card-text>
        <v-data-table :headers="headers" :items="products" :search="search" :loading="loading" :sort-by="sortBy"
          :page.sync="page" :items-per-page="itemsPerPage">
          <template v-slot:item="{ item }">
            <tr class="pointer">

              <td class="text-left">
                <ImageIcon :item="item" type="product" />

                <span v-html="
                  $options.filters.highlight(item.name, search.toLowerCase())
                ">{{ item.name }}</span>
                <v-chip v-if="item.isFee" class="ml-2" color="pink" label text-color="white">
                  <v-icon left>
                    mdi-label
                  </v-icon>
                  School Fee
                </v-chip>

              </td>

              <td class="text-left">
                <span v-if="item.Category">{{ item.Category.name }}</span>
                <span v-else>
                  <v-chip small color="pink" text-color="white" class="font-weight-bold" label>
                    Category Not Selected
                  </v-chip>
                </span>
              </td>

              <td class="text-right">
                <span class="mr-2">{{ item.price | currency }}</span>
              </td>

              <td class="justify-end align-center text-right">
                <v-menu bottom left offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon>
                      <v-icon>more_vert</v-icon>
                    </v-btn>
                  </template>
                  <v-list class="menu-button">
                    <v-list-item v-if="checkRightStatus(17)" @click="editProduct(item)">
                      <v-list-item-title>{{
                          $t("buttons.edit")
                      }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="checkRightStatus(9)" @click="deleteProduct(item)">
                      <v-list-item-title>{{
                          $t("buttons.delete")
                      }}</v-list-item-title>
                    </v-list-item>
                    <v-divider v-if="!item.trackSerialNumber"></v-divider>
                    <v-list-item v-if="item.balance > 0" @click="viewAvgCost(item)">
                      <v-list-item-title>View Avg Cost</v-list-item-title>
                    </v-list-item>
                    <v-divider v-if="item.trackSerialNumber"></v-divider>
                    <v-list-item v-if="item.trackSerialNumber" @click="inventoryAdj(item)">
                      <v-list-item-title>Inventory Count</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
            </tr>
          </template>
          <!-- <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length" class="pa-0">
              <v-card dark color="#F3F8FC" text class="elevation-0">
                <v-card-text class="title">
                  <PurchaseDetialList :ProductId="item.id"></PurchaseDetialList>
                </v-card-text>
              </v-card>
            </td>
          </template> -->
          <v-alert slot="no-results" :value="true" color="error" icon="warning">Your search for "{{ search }}" found no
            results.</v-alert>
        </v-data-table>
      </v-card-text>
    </v-card>
    <v-dialog v-model="dialog" width="500">
      <v-card v-if="selectedProduct">
        <v-card-title primary-title>
          <v-layout row class="pa-3">
            <v-flex> Avg Cost </v-flex>
            <v-spacer></v-spacer>
            <v-flex shrink v-if="selectedProduct">
              {{ selectedProduct.id }}
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-card-text>
          <v-card dark flat>
            <v-card-text>
              <div class="text-center white--text font-weight-thin">
                <v-progress-circular indeterminate :size="70" v-if="!selectedProduct" :width="7" color="white">
                </v-progress-circular>
                <div v-else>
                  <v-col class="text-h5">
                    <v-col>
                      <v-row>
                        <v-col sm="6">
                          <div>Stock</div>
                          <div>{{ selectedProduct.totalQty }}</div>
                        </v-col>

                        <v-col sm="6">
                          <div>Cost</div>
                          <div>{{ selectedProduct.totalCost | currency }}</div>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-divider></v-divider>
                    <v-col class="text-h1">
                      {{ selectedProduct.avgCost | currency }}
                    </v-col>
                  </v-col>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import productService from "../service";
// import PurchaseDetialList from "@/modules/Inventory/Purchase/components/PurchaseDetailList";
import ImageIcon from "@/components/Image/ImageIcon.vue";
import { mapGetters } from "vuex";

const Create = () => import("./Create");
const Edit = () => import("./Edit");

export default {
  name: "product-list",
  data() {
    return {
      id: 0,
      dialog: false,
      expanded: [],
      singleExpand: true,
      hideZeroProduct: false,
      createDialog: false,
      editDialog: false,
      selectedProduct: null,
      headers: [
        {
          text: this.$t("labels.name"),
          align: "left",
          value: "name",
          sortable: true,
        },
        {
          text: "Category",
          align: "left",
          value: "category",
          sortable: true,
        },
        {
          text: this.$t("labels.amount"),
          value: "price",
          align: "right",
          sortable: true,
        },
        {
          text: "",
          value: "action",
          sortable: false,
        },
      ],
      products: [],
      search: "",
      loading: true,
      page: 1,
      sortBy: "name",
      pageCount: 0,
      itemsPerPage: 10,
    };
  },
  created() {
    this.getList();
    if (this.$route.query && this.$route.query.search) {
      this.search = this.$route.query.search;
    }
    document.title = "taleem - Product";
  },
  components: {
    Create,
    ImageIcon,
    Edit,
    // PurchaseDetialList,
  },
  filters: {
    highlight(words, query) {
      if (query) {
        var check = new RegExp(query.toLowerCase(), "ig");
        if (words) {
          return words.toString().replace(check, function (matchedText) {
            return '<span class="highlight">' + matchedText + "</span>";
          });
        } else {
          return words;
        }
      } else {
        return words;
      }
    },
  },
  watch: {
    hideZeroProduct() {
      this.getList();
    },
    search(val) {
      if (!val) {
        this.search = "";
      }
    },
  },
  computed: {
    ...mapGetters("global", ["currentUser", "checkRightStatus"]),
  },
  methods: {
    inventoryAdj(item) {
      this.$router.push({ path: `/product/inventoryAdj/${item.id}` });
    },
    viewAvgCost(item) {
      productService.getAvgCost(item.id).then((response) => {
        this.selectedProduct = response.data.product;
        item.avgCost = response.data.avgCost;
        this.selectedProduct.totalCost = response.data.totalCost;
        this.selectedProduct.totalQty = response.data.totalQty;
      });

      console.log("priess view avt gost", item);
      this.dialog = true;
    },
    add() {
      this.createDialog = !this.createDialog;
    },
    getList() {
      this.loading = true;
      this.editDialog = false;
      this.createDialog = false;
      return productService.getAll().then((response) => {
        this.loading = false;
        const product = response.data;
        this.products = [];
        if (this.hideZeroProduct) {
          product.map((row) => {
            if (row.balance > 0) this.products.push(row);
          });
        } else {
          this.products = product;
        }
        return response;
      });
    },
    editProduct(product) {
      this.selectedProduct = product;
      this.id = product.id;
      this.editDialog = !this.editDialog;
    },
    deleteProduct(product) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#B71C1C",
        cancelButtonColor: "#43A047",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          productService.delete(product.id).then((response) => {
            if (response.data) {
              this.$swal("Deleted!", "Product has been deleted.", "success");
              this.getList();
            }
          });
        }
      });
    },
  },
};
</script>
